import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/MonitoringHarianNicuService";
import {
  MonitoringHarianNicuInterface,
  MonitoringHarianNicuListItem,
  NicuAlertItem
} from "@/types/monitoring_harian_nicu";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "monitoring-harian-nicu"
})
class MonitoringHarianNicuStore extends VuexModule {
  loading = false;
  list: MonitoringHarianNicuListItem[] = [];
  current: MonitoringHarianNicuInterface | null = null;
  alerts: NicuAlertItem[] = [];

  @Mutation
  SET_LIST(val: MonitoringHarianNicuListItem[]) {
    this.list = val;
  }

  @Mutation
  SET_CURRENT(val: MonitoringHarianNicuInterface | null) {
    this.current = val;
    this.alerts = val && val.alerts ? val.alerts : [];
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.list = [];
    this.current = null;
    this.alerts = [];
    this.loading = false;
  }

  @Action({ rawError: true })
  async fetchByRegister(registerId: string | number): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_LIST(response.data?.data || []);
  }

  @Action({ rawError: true })
  async fetchByDate(params: { registerId: string | number; tanggal: string }): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByDate(params.registerId, params.tanggal).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
  }

  @Action({ rawError: true })
  async createMonitoring(data): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.create(data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async updateMonitoring(params: { id: number; data: any }): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.update(params.id, params.data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async deleteMonitoring(id: number): Promise<void> {
    this.SET_LOADING(true);
    await Service.destroy(id).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(null);
  }

  @Action({ rawError: true })
  async carryForward(params: { registerId: string | number; data: any }): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.carryForward(params.registerId, params.data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async verifyDpjp(id: number): Promise<any> {
    const response = await Service.verifyDpjp(id);
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(MonitoringHarianNicuStore);
